export const CANVAS_WIDTH = 2056;
export const CANVAS_HEIGHT = 1024;
export const LOGO_HEIGHT = 220;